const dentalTourism = {
  hero: {
    title: "ДЕНТАЛЕН ТУРИЗЪМ В БЪЛГАРИЯ",
    description:
      "Насладете се на дентално обслужване от световна величина. Нашите цялостни пакети за дентален туризъм съчетават отлично дентално лечение и туристическо преживяване.",
    ctas: {
      primary: "Запишете Безплатна Консултация",
      secondary: "Научете Повече",
    },
    imageAlt: "Дентален Туризъм в България - Кацащ Самолет",
  },
  benefits: {
    heading: "ЗАЩО ДА ИЗБЕРЕТЕ НАС",
    intro:
      "Изпитайте перфектната комбинация от достъпна, висококачествена дентална грижа и незабравими пътешествия",
    items: [
      {
        title: "Спестяване на Разходи",
        description:
          "Спестете до 70% от цените на денталните процедури в сравнение със Западна Европа и Северна Америка, без да правите компромис с качеството.",
      },
      {
        title: "Качествена Грижа",
        description:
          "Нашите зъболекари са висококвалифицирани с международно обучение и използват най-новите дентални технологии и материали.",
      },
      {
        title: "Пакети Всичко Включено",
        description:
          "Цялостните пакети включват дентално лечение, настаняване, трансфери от/до летището и опционални туристически дейности.",
      },
      {
        title: "Времева Ефективност",
        description:
          "Сложни лечения, които другаде биха отнели месеци, могат да бъдат завършени при едно посещение с нашето ефективно планиране.",
      },
      {
        title: "Културно Преживяване",
        description:
          "Съчетайте денталното си лечение с обогатяващо пътуване, изследвайки богатата история и природна красота на България.",
      },
      {
        title: "Персонализирана Грижа",
        description:
          "Получете индивидуално внимание с отдаден екип, говорещ английски език, който ще ви води през всяка стъпка от вашето пътуване.",
      },
    ],
  },
  process: {
    heading: "КАК РАБОТИ",
    intro:
      "Нашият оптимизиран процес за дентален туризъм прави лесно получаването на качествена дентална грижа, докато се наслаждавате на незабравимо пътуване в България",
    steps: [
      {
        number: "01",
        title: "Първоначална Консултация",
        description:
          "Свържете се с нас за безплатна онлайн консултация, за да обсъдим вашите дентални нужди, възможности за лечение и приблизителни разходи.",
      },
      {
        number: "02",
        title: "План за Лечение",
        description:
          "Предоставяме подробен план за лечение с прогнозна цена и възможности за график на вашето посещение в България.",
      },
      {
        number: "03",
        title: "Организация на Пътуването",
        description:
          "Нашите координатори помагат с резервации за полети, опции за настаняване и транспорт от летището до вашия хотел.",
      },
      {
        number: "04",
        title: "Дентално Лечение",
        description:
          "Получете висококачествена дентална грижа от нашите опитни специалисти в модерната ни клиника в България.",
      },
      {
        number: "05",
        title: "Туристически Дейности",
        description:
          "Между прегледите, разгледайте България с нашите екскурзоводи и изпитайте местната култура, кухня и забележителности.",
      },
      {
        number: "06",
        title: "Последващи Грижи",
        description:
          "Върнете се у дома с новата си усмивка и получете дистанционни последващи грижи, за да гарантираме вашето пълно удовлетворение.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro:
      "Получете отговори на често задавани въпроси за нашите услуги за дентален туризъм в България",
    items: [
      {
        question: "Колко мога да спестя с дентален туризъм в България?",
        answer:
          "Пациентите обикновено спестяват между 50-70% от цените на денталните процедури в сравнение със Западна Европа и Северна Америка. Например, зъбен имплант, който може да струва 3000€ в Западна Европа, би струвал около 900-1200€ в България.",
      },
      {
        question: "Квалифицирани и опитни ли са вашите зъболекари?",
        answer:
          "Да, всички наши зъболекари са висококвалифицирани с дипломи от престижни дентални училища. Много от тях имат международно обучение и сертификати, и всички се поддържат в крак с най-новите дентални техники и технологии.",
      },
      {
        question: "Какви езици говори вашият персонал?",
        answer:
          "Нашата клиника разполага със зъболекари и персонал, говорещи английски език. Имаме също преводачи на разположение за няколко други езика, включително немски, френски и руски при поискване.",
      },
      {
        question: "Колко време ще трябва да остана в България за моето лечение?",
        answer:
          "Продължителността на престоя зависи от вашия специфичен план за лечение. Простите процедури може да изискват само 2-3 дни, докато по-сложните лечения като пълна рехабилитация на устната кухина може да се нуждаят от 7-14 дни, често с почивки между прегледите.",
      },
      {
        question: "Предоставяте ли услуги за настаняване и транспорт?",
        answer:
          "Да, предлагаме цялостни пакети, които включват препоръки за настаняване, трансфери от/до летището и транспорт до и от клиниката. Можем да организираме всичко според вашите предпочитания и бюджет.",
      },
      {
        question: "Какво се случва, ако имам нужда от последващи грижи след връщане у дома?",
        answer:
          "Предоставяме подробни инструкции за последващи грижи преди да заминете. В случай че се нуждаете от помощ, предлагаме дистанционни консултации чрез видео разговор. За лечения с гаранции работим с партньорски клиники в различни страни за последващи грижи при необходимост.",
      },
      {
        question: "Безопасна страна ли е България за посещение?",
        answer:
          "Да, България е безопасна страна с относително ниско ниво на престъпност в сравнение с много западни страни. Тя е член на Европейския съюз и следва стандартите на ЕС за здравеопазване и безопасност.",
      },
      {
        question: "Какви туристически забележителности мога да посетя между денталните прегледи?",
        answer:
          "България предлага разнообразни атракции, включително красиви плажове на Черно море, планински курорти, исторически градове, древни римски руини и известни минерални извори. Можем да организираме екскурзии с екскурзовод или да предоставим препоръки според вашите интереси.",
      },
    ],
    bottomLine: "Имате още въпроси за нашите услуги за дентален туризъм?",
    cta: "Запишете Безплатна Консултация",
  },
};

export default dentalTourism;

